<template>
  <div class="mj_page flex jb">
    <div class="left_area">
      <div class="left_top">
        <div class="scrollable-content">
          <div class="toolsIntroduce">
            <div class="right">
              <div>
                发型编辑
              </div>
              <span>
                能够精准识别人像区域，实现一键更换发型和发色。您可以选择多达数十种发型和发色组合，轻松打造您独特的个性化造型，满足不同的美发需求。
              </span>
            </div>
          </div>
          <div class="describe">
            <div class="refer_title">
              <div></div>
              上传图片（必填）
                <el-tooltip class="item" effect="dark"
                            placement="top-start">
                  <template v-slot:content>
                    <div>
                      <p style="line-height: 1.4">1.最小面部比例:为了确保效果，图像中面部的比例不能少于20%。</p>
                      <p style="line-height: 1.4">2.面部完整性:为了确保有效性，图像中的面部理想情况下不应被遮挡。</p>
                      <p style="line-height: 1.4">3.面部角度:为确保效果，图像中的面部最好为正面视角，且左转或右转的角度不应超过45度。</p>
                    </div>
                  </template>
                  <img style="width: 18px;height: 18px" src="../img/032.png" alt="">
                </el-tooltip>
            </div>
            <div class="Reference_image"
                 v-loading="upmjloading"
                 element-loading-background="rgba(122, 122, 122, 0.8)">
              <el-upload
                  class="upload-demo"
                  drag
                  :action="fileApi+'/api/front/upload/?fdir=mj_tool'"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  accept="image/jpeg, image/png, image/bmp"
                  multiple>
                <div v-if="form.iw_url" class="yesUpload">
                  <img :src="form.iw_url" alt="" class="yesUpload_img">
                  <div class="yesUpload_icon" @click.stop="form.iw_url=''">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
                <div v-else class="noUpload">
                  <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                  <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                  <div> 只能上传jpg/png文件，且不超过3MB</div>
                </div>
              </el-upload>
            </div>
          </div>

          <div class="describe" >
            <div class="refer_title">
              <div></div>
              发型选择
            </div>
            <div class="toolsModelList">
              <div class="music_style">
                <span :class="clickImgStyle.sign===item.sign?'spanColor':''"
                      v-for="item in musicStyle"
                      @click="clickLoraStyleList(item)">
                  {{ item.style }}
                </span>
              </div>
              <!--              <div class="music_styleImg" :style="{height:expand?270+'px':'auto'}">-->
              <div class="music_styleImg" :style="{height:clickImgStyle.shou?expand?270+'px':'auto':'auto'}">
                <div @click="listClick(item,'list1')"
                     :class="clickImgStyle.num===item.num? 'item_click':'styleImg_item'"
                     v-for="item in clickImgStyleList" v-if="item.sign.includes(clickImgStyle.sign) ">
                  <img alt="" :src="item.src">
                  <div>
                    {{ item.title }}
                  </div>
                </div>
              </div>
              <div class="upDown" @click="expand=!expand" v-if="clickImgStyle.shou">
                <img v-if="expand" alt="" src='./img/down2.png' height="14" width="15"/>
                <img v-if="!expand" alt="" src="./img/upward.png" height="13" width="14"/>
              </div>
            </div>
          </div>

<!--          <div class="describe" >-->
<!--            <div class="refer_title">-->
<!--              <div></div>-->
<!--              发色选择-->
<!--            </div>-->
<!--            <div class="toolsModelList">-->
<!--              <div class="music_styleImg" :style="{height:clickImgStyle.shou2?expand2?270+'px':'auto':'auto'}">-->
<!--                <div @click="clickImgStyle.num2=item.num;form.hair_color=item.type"-->
<!--                     :class="clickImgStyle.num2===item.num? 'item_click':'styleImg_item'"-->
<!--                     v-for="item in clickImgStyleList2">-->
<!--                  <img alt="" :src="item.src">-->
<!--                  <div>-->
<!--                    {{ item.title }}-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="upDown" @click="expand2=!expand2">-->
<!--                <img v-if="expand2" alt="" src='./img/down2.png' height="14" width="15"/>-->
<!--                <img v-if="!expand2" alt="" src="./img/upward.png" height="13" width="14"/>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 参数
      form: {
        // 上传图片
        iw_url:'',
        hair_style:'BuzzCut', // 发型选择
        hair_color:'blonde', // 发型颜色
      },
      // 上传图片
      fileApi: FILE_API_SERVER,
      upmjloading:false,
      clickImgStyle: {num: 1,num2: 1, sign: 1, shou: true,shou2: true,},
      clickImgStyleList: [
        {num: 1, type:'BuzzCut', sign: [1], title: '寸头', select: false, scale: 0.8, src: require('./emitHairstyleeditor/1.png'),},
        {num: 2, type:'UnderCut', sign: [1], title: 'Undercut', select: false, scale: 0.8, src: require('./emitHairstyleeditor/2.png'),},
        {num: 3, type:'Pompadour', sign: [1], title: '庞巴度', select: false, scale: 0.8, src: require('./emitHairstyleeditor/3.png'),},
        {num: 4, type:'SlickBack', sign: [1], title: 'Slick Back', select: false, scale: 0.8, src: require('./emitHairstyleeditor/4.png'),},
        {num: 5, type:'CurlyShag', sign: [1], title: 'Curly Shag', select: false, scale: 0.8, src: require('./emitHairstyleeditor/5.png'),},
        {num: 6, type:'WavyShag', sign: [1], title: 'Wavy Shag', select: false, scale: 0.8, src: require('./emitHairstyleeditor/6.png'),},
        {num: 7, type:'FauxHawk', sign: [1], title: 'Faux Hawk', select: false, scale: 0.8, src: require('./emitHairstyleeditor/7.png'),},
        {num: 8, type:'Spiky', sign: [1], title: 'Spiky', select: false, scale: 0.8, src: require('./emitHairstyleeditor/8.png'),},
        {num: 9, type:'CombOver', sign: [1], title: 'Comb-over', select: false, scale: 0.8, src: require('./emitHairstyleeditor/9.png'),},
        {num: 10, type:'HighTightFade', sign: [1], title: ' HighandTightFade', select: false, scale: 0.8, src: require('./emitHairstyleeditor/10.png'),},
        {num: 11, type:'ManBun', sign: [1], title: 'Man Bun', select: false, scale: 0.8, src: require('./emitHairstyleeditor/11.png'),},
        {num: 12, type:'Afro', sign: [1], title: 'Afro', select: false, scale: 0.8, src: require('./emitHairstyleeditor/12.png'),},
        {num: 13, type:'LowFade', sign: [1], title: 'Low Fade', select: false, scale: 0.8, src: require('./emitHairstyleeditor/13.png'),},
        {num: 14, type:'UndercutLongHair', sign: [1], title: '长发Undercut', select: false, scale: 0.8, src: require('./emitHairstyleeditor/14.png'),},
        {num: 15, type:'TwoBlockHaircut', sign: [1], title: 'Two Block', select: false, scale: 0.8, src: require('./emitHairstyleeditor/15.png'),},
        {num: 16, type:'TexturedFringe', sign: [1], title: 'Textured Fringe', select: false, scale: 0.8, src: require('./emitHairstyleeditor/16.png'),},
        {num: 17, type:'BluntBowlCut', sign: [1], title: 'Blunt Bowl Cut', select: false, scale: 0.8, src: require('./emitHairstyleeditor/17.png'),},
        {num: 18, type:'LongWavyCurtainBangs', sign: [1], title: '长卷幕帘刘海', select: false, scale: 0.8, src: require('./emitHairstyleeditor/18.png'),},
        {num: 19, type:'MessyTousled', sign: [1], title: '凌乱', select: false, scale: 0.8, src: require('./emitHairstyleeditor/19.png'),},
        {num: 20, type:'CornrowBraids', sign: [1], title: '辫子', select: false, scale: 0.8, src: require('./emitHairstyleeditor/20.png'),},
        {num: 21, type:'LongHairTiedUp', sign: [1], title: '长发束发', select: false, scale: 0.8, src: require('./emitHairstyleeditor/21.png'),},
        {num: 22, type:'Middle-parted', sign: [1], title: '中分', select: false, scale: 0.8, src: require('./emitHairstyleeditor/22.png'),},
        {num: 23, type:'ShortPixieWithShavedSides', sign: [2], title: '剃侧短精灵', select: false, scale: 0.8, src: require('./emitHairstyleeditor/23.png'),},
        {num: 24, type:'ShortNeatBob', sign: [2], title: '干练短波', select: false, scale: 0.8, src: require('./emitHairstyleeditor/24.png'),},
        {num: 25, type:'DoubleBun', sign: [2], title: '双丸子头', select: false, scale: 0.8, src: require('./emitHairstyleeditor/25.png'),},
        {num: 26, type:'Updo', sign: [2], title: '盘发', select: false, scale: 0.8, src: require('./emitHairstyleeditor/26.png'),},
        {num: 27, type:'Spiked', sign: [2], title: '刺猬发型', select: false, scale: 0.8, src: require('./emitHairstyleeditor/27.png'),},
        {num: 28, type:'bowlCut', sign: [2], title: '锅盖头', select: false, scale: 0.8, src: require('./emitHairstyleeditor/28.png'),},
        {num: 29, type:'Chignon', sign: [2], title: '发髻', select: false, scale: 0.8, src: require('./emitHairstyleeditor/29.png'),},
        {num: 30, type:'PixieCut', sign: [2], title: '精灵短发', select: false, scale: 0.8, src: require('./emitHairstyleeditor/30.png'),},
        {num: 31, type:'SlickedBack', sign: [2], title: '背头', select: false, scale: 0.8, src: require('./emitHairstyleeditor/31.png'),},
        {num: 32, type:'LongCurly', sign: [2], title: '长卷发', select: false, scale: 0.8, src: require('./emitHairstyleeditor/32.png'),},
        {num: 33, type:'CurlyBob', sign: [2], title: '短卷波', select: false, scale: 0.8, src: require('./emitHairstyleeditor/33.png'),},
        {num: 34, type:'StackedCurlsInShortBob', sign: [2], title: '层叠卷发', select: false, scale: 0.8, src: require('./emitHairstyleeditor/34.png'),},
        {num: 35, type:'SidePartCombOverHairstyleWithHighFade', sign: [2], title: '高渐变侧分', select: false, scale: 0.8, src: require('./emitHairstyleeditor/35.png'),},
        {num: 36, type:'WavyFrenchBobVibesfrom1920', sign: [2], title: '法式波波', select: false, scale: 0.8, src: require('./emitHairstyleeditor/36.png'),},
        {num: 37, type:'BobCut', sign: [2], title: '经典波波', select: false, scale: 0.8, src: require('./emitHairstyleeditor/37.png'),},
        {num: 38, type:'ShortTwintails', sign: [2], title: '短双马尾', select: false, scale: 0.8, src: require('./emitHairstyleeditor/38.png'),},
        {num: 39, type:'ShortCurlyPixie', sign: [2], title: '短卷精灵', select: false, scale: 0.8, src: require('./emitHairstyleeditor/39.png'),},
        {num: 40, type:'LongStraight', sign: [2], title: '长直发', select: false, scale: 0.8, src: require('./emitHairstyleeditor/40.png'),},
        {num: 41, type:'LongWavy', sign: [2], title: '长波浪发', select: false, scale: 0.8, src: require('./emitHairstyleeditor/41.png'),},
        {num: 42, type:'FishtailBraid', sign: [2], title: '鱼尾辫', select: false, scale: 0.8, src: require('./emitHairstyleeditor/42.png'),},
        {num: 43, type:'TwinBraids', sign: [2], title: '双辫子', select: false, scale: 0.8, src: require('./emitHairstyleeditor/43.png'),},
        {num: 44, type:'Ponytail', sign: [2], title: '马尾', select: false, scale: 0.8, src: require('./emitHairstyleeditor/44.png'),},
        {num: 45, type:'Dreadlocks', sign: [2], title: '脏辫', select: false, scale: 0.8, src: require('./emitHairstyleeditor/45.png'),},
        {num: 46, type:'Cornrows', sign: [2], title: '玉米辫', select: false, scale: 0.8, src: require('./emitHairstyleeditor/46.png'),},
        {num: 47, type:'ShoulderLengthHair', sign: [2], title: '齐肩直发', select: false, scale: 0.8, src: require('./emitHairstyleeditor/47.png'),},
        {num: 48, type:'LooseCurlyAfro', sign: [2], title: '蓬松卷发', select: false, scale: 0.8, src: require('./emitHairstyleeditor/48.png'),},
        {num: 49, type:'LongTwintails', sign: [2], title: '长双马尾', select: false, scale: 0.8, src: require('./emitHairstyleeditor/49.png'),},
        {num: 50, type:'LongHimeCut', sign: [2], title: '长姬发', select: false, scale: 0.8, src: require('./emitHairstyleeditor/50.png'),},
        {num: 51, type:'BoxBraids', sign: [2], title: '方形辫', select: false, scale: 0.8, src: require('./emitHairstyleeditor/51.png'),},
      ],
      musicStyle: [
        {style: '男士', sign: 1, num: 1, shou:true ,hair_style:'BuzzCut',},
        {style: '女士', sign: 2, num: 23, shou: true,hair_style:'ShortPixieWithShavedSides',},
      ],
      clickImgStyleList2: [
        {num: 1, type:'blonde', sign: [1], title: '金色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/52.png'),},
        {num: 2, type:'platinumBlonde', sign: [1], title: '铂金金发', select: false, scale: 0.8, src: require('./emitHairstyleeditor/53.png'),},
        {num: 3, type:'brown', sign: [1], title: '棕色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/54.png'),},
        {num: 4, type:'lightBrown', sign: [1], title: '浅棕色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/55.png'),},
        {num: 5, type:'blue', sign: [1], title: '蓝色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/56.png'),},
        {num: 6, type:'lightBlue', sign: [1], title: '浅蓝色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/57.png'),},
        {num: 7, type:'purple', sign: [1], title: '紫色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/58.png'),},
        {num: 8, type:'lightPurple', sign: [1], title: '浅紫色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/59.png'),},
        {num: 9, type:'pink', sign: [1], title: '粉色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/60.png'),},
        {num: 10, type:'black', sign: [1], title: '黑色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/61.png'),},
        {num: 11, type:'white', sign: [1], title: '白色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/62.png'),},
        {num: 12, type:'grey', sign: [1], title: '灰色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/63.png'),},
        {num: 13, type:'silver', sign: [1], title: '银色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/64.png'),},
        {num: 14, type:'red', sign: [1], title: '红色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/65.png'),},
        {num: 15, type:'orange', sign: [1], title: '橙色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/66.png'),},
        {num: 16, type:'green', sign: [1], title: '绿色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/67.png'),},
        {num: 17, type:'gradient', sign: [1], title: '渐变', select: false, scale: 0.8, src: require('./emitHairstyleeditor/68.png'),},
        {num: 18, type:'multicolored', sign: [1], title: '多色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/69.png'),},
        {num: 19, type:'darkBlue', sign: [1], title: '深蓝', select: false, scale: 0.8, src: require('./emitHairstyleeditor/70.png'),},
        {num: 20, type:'burgundy', sign: [1], title: '酒红色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/71.png'),},
        {num: 21, type:'darkGreen', sign: [1], title: '深绿色', select: false, scale: 0.8, src: require('./emitHairstyleeditor/72.png'),},
      ],
      expand: true,
      expand2: true,

    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    listClick(item){
      this.clickImgStyle.num=item.num
      this.form.hair_style=item.type
    },
    clickLoraStyleList(item, modle) {

      this.clickImgStyle.sign = item.sign
      this.clickImgStyle.num = item.num
      this.clickImgStyle.shou = item.shou
      this.form.hair_style = item.hair_style
    },
    // 上传图片
    handleAvatarSuccess(res,) {
      this.upmjloading = false
      if(res.data.error !== ''){
        this.$message.error(res.data.error);
        return
      }
      this.form.iw_url = res.data.file_full_url;
    },
    beforeAvatarUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      const isValidType = ['image/jpeg', 'image/png', 'image/bmp'].includes(file.type);

      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const { width, height } = img;
          // const isValidResolution =  width <= 4096 &&  height <= 4096;
          const isValidResolution = width >= 10 && width <= 2000 && height >= 10 && height <= 2000;


          if (!isValidType) {
            this.$message.error('只能上传 JPG/JPEG/PNG/BMP 格式的文件!');
            reject({ isValidType: false });
            return
          }

          if (!isLt3M) {
            this.$message.error('上传文件大小不能超过 3MB!');
            reject({ isLt3M: false });
            return
          }

          if (!isValidResolution) {
            // this.$message.error('图片分辨率需小于 4096x4096 像素!');
            this.$message.error('图片分辨率需大于 10x10 像素且小于 2000x2000 像素!');
            reject({ isValidResolution: false });
            return
          }
          this.upmjloading = true

          resolve({ isValidType, isLt3M, isValidResolution, });
        };
        img.onerror = () => {
          this.$message.error('无法读取图片分辨率，请检查图片是否损坏！');
          reject({ isImageValid: false });
        };
      });
    },

  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@keyframes scale-breathe {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.05);
  }
  75% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}


.mj_page {
  width: 100%;
  height: 100%;
  background: #2b2d31;
  border-radius: 10px;
  display: flex;
  //align-items: center;
  //justify-content: center;
}

.left_area {
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .createButton {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 0;
    border-top: 1px solid #36373d;

    div {
      font-size: 16px;
      cursor: pointer;
      background-color: #5865f2;
      color: #fff;
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 30px;

      span {
        font-size: 12px;
      }
    }
  }

  .left_top {
    height: calc(100% - 76px);
    //overflow-y: auto;
    .goBack {
      margin: 5px 0 15px 0;
      font-size: 14px;
      color: #fff;
      display: flex;

      .iconFont {
        display: flex;
        margin-right: 20px;

        div {
          display: flex;
          align-items: center;
          position: relative;
          overflow: hidden;
          width: 16px;
          margin-right: 5px;

          img {
            width: 100%;
            //height: 100%;
            vertical-align: top;
            opacity: 1;
          }
        }
      }

      .font_title {
        font-weight: 700;
      }

    }
  }

  .left_nav {
    padding: 4px 0;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #36373d;
    display: flex;
    align-items: center;

    color: #fff;

    div {
      flex: 1;
      text-align: center;
      margin: 0 4px;
      cursor: pointer;
    }

    .navSelected {
      background-color: #5865f2;
      border-radius: 4px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }

  .scrollable-content {
    overflow-y: auto;
    height: calc(100% - 120px);
    margin: 10px 0;
    color: #fff;

    .toolsIntroduce {
      background-color: #1e1f22;
      padding: 16px 14px;
      display: flex;
      border-radius: 5px;

      .left {
        margin-right: 12px;
        width: 20px;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .right {
        flex: 1;


        div {
          font-size: 14px;
          font-weight: 700;
          height: 20px;
          margin-bottom: 5px;
        }

        span {
          font-size: 12px;
          line-height: 20px;
        }

      }
    }

    .describe {
      .refer_title {
        height: 18px;
        margin: 15px 0;
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 1;

        div {
          height: 100%;
          border: 2px solid #5865f2;
          border-radius: 2px;
          margin-right: 5px;
        }
      }

      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;

        .upload-demo {
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 280px;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }

        .yesUpload {
          position: relative;

          .yesUpload_img {
            height: 140px;
          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #c1bfbb;
            font-size: 25px;
          }

        }
      }

      .toolsModelList {

        .music_style {
          overflow-x: auto;
          width: 100%;
          white-space: nowrap;
          padding: 0 0 5px 0;

          span {
            font-size: 14px;
            margin-right: 15px;
            cursor: pointer;

          }

          .spanColor {
            color: #5865f2;
          }
        }
        .music_style::-webkit-scrollbar {
          height: 5px !important;
        }

        .music_styleImg {
          padding: 0 0 0 0;
          display: flex;
          flex-wrap: wrap;

          //height: 270px;
          overflow: hidden;
          gap: 5px 10px;

          .styleImg_item {
            width: 83px;
            height: 83px;
            position: relative;
            border: 2px solid #5865f200;
            border-radius: 5px;
            overflow: hidden;
            margin: 2px 0;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }

            div {
              width: 100%;
              padding: 2px 0;
              text-align: center;
              font-size: 12px;
              background-color: #000000ac;
              position: absolute;
              left: 0;
              bottom: 0;

            }

          }

          .item_click {
            border: 2px solid #5865f2;
            width: 83px;
            height: 83px;
            position: relative;
            border-radius: 5px;
            margin: 2px 0;
            cursor: pointer;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }

            div {
              width: 100%;
              padding: 2px 0;
              text-align: center;
              font-size: 12px;
              background-color: #000000ac;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }
        }

        .upDown {
          background-color: #1e1f22;
          padding: 5px 0;
          display: flex;
          cursor: pointer;

          img {
            margin: 0 auto;
          }
        }

      }
      .parameter {
        width: 100%;
        padding: 15px 15px;
        border-radius: 6px;
        background-color: #1d2027;
        font-size: 14px;
        overflow: hidden;

        .parameter_title {
          margin: 0 0 5px 0;
        }

        .parameter_slider {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .slider_num {
            width: 40px;
            height: 28px;
            background-color: #2d313b;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;

          }

          .slider {
            flex: 1;
            margin: 0 0 0 10px;

            /deep/ .el-slider__bar {
              background-color: #5865f2;
            }

            /deep/ .el-slider__button {
              border-color: #FFF;
              cursor: grab;
            }
          }
        }

        .Negative_Prom {
          .Negative_text {
            width: 100%;
            height: 50px;
            background-color: #313338;
            border: 2px solid #393c43;
            color: #c7d2c9;
            padding: 5px 5px;
            font-size: 14px;
            border-radius: 4px;
          }

          textarea::placeholder {
            color: #a8abb2; /* 将颜色改为灰色 */
          }

        }
      }
      .music_style::-webkit-scrollbar {
        height: 5px !important;
      }

    }
  }
}


.fz13 {
  font-size: 13px;
}

.c-fff {
  color: #fff;
}




.con {
  width: 410px;
  height: 560px;
  padding: 20px;
  background-color: #1e1f22;
  border: 2px solid #5865f2;
  border-radius: 6px;

  .full {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;



    .avatar {
      flex-direction: column;
      cursor: pointer;

      .pic {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        margin-bottom: 5px;
        margin-top: 5px;
      }

      .text {
        font-size: 14px;
        color: #fff;

        img {
          width: 14px;
          height: 14px;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .info_list {
      padding: 15px 18px;

      .info_list_title {
        font-size: 14px;
        color: #fff;
        margin-left: -16px;
      }

      .info_item {
        padding: 15px 0;
        border-bottom: 1px solid #36373d;

        .title {
          img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }

          p {
            font-size: 14px;
            color: #b0b0b0;
          }
        }

        .text {
          font-size: 14px;
          color: #b0b0b0;

          .btn {
            padding: 0 14px;
            display: block;
            line-height: 34px;
            cursor: pointer;
            background-color: #5865f2;
            color: #fff;
            border-radius: 4px;

            &:hover {
              background-color: rgba(88, 101, 242, 0.867);
            }
          }
        }
      }
    }
  }
}


.create_error {
  width: 190px;
  height: 190px;
  background-color: #fff;
  border-radius: 4px;
  padding-top: 28px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    line-height: 64px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
}

.defeat_popup {
  width: 600px;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 76px;
    text-align: center;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_item {
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;

      .item_answer {
        color: #999;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}


.Image_manipulation {
  //width: 500px;
  background-color: #3f3c3a;
  padding: 20px 20px;
  border-radius: 4px;
  position: relative;

  .clear {
    position: absolute;
    top: 0;
    right: 0;
    //background-color: #5865f2;
    border: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-icon-error {
      font-size: 20px;
      color: #565658;
    }
  }

  .clear:hover {
    background-color: #343538;
  }
}



.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 360px;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

</style>